import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/no-record.png'


const _withScopeId = n => (_pushScopeId("data-v-40968ddc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-actives" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "我参与的公益")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "active-list"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "top" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "txt-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, "已报名", -1))
const _hoisted_9 = {
  key: 1,
  class: "no-record"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "你还没有参加活动", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("前往「公益活动」报名")

import { ref, onMounted } from 'vue';
import { searchInfo, UserService } from '@/api/request';
import config from '@/_config';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const list = ref([]);
onMounted(() => {
  getList();
  onClickTag('4', '我参加的公益');
});
const getList = async() => {
  const res = await searchInfo.sjqnwAttendedEvents();
  list.value = res.body;
};
const IsPC = () => {
  var userAgentInfo = navigator.userAgent;
  var Agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod'
  ];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};
const onClickTag = (id: string, title: string) => {
  const params = {
    eventId: id,
    eventTitle: title,
    channel: IsPC() ? '1' : '2'
  };
  UserService.sjqnwStatistics(params);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (list.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list-content",
              key: index
            }, [
              _createElementVNode("a", {
                href: 'article?articleId=' + item.id
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: _unref(config).articleUrl + item.coverUrl,
                    alt: ""
                  }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h3", null, _toDisplayString(item.articleTitle), 1),
                  _createElementVNode("p", null, _toDisplayString(item.author), 1),
                  _hoisted_8
                ])
              ], 8, _hoisted_4)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _hoisted_11,
          _createVNode(_component_router_link, { to: "/publicWelfare" }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})